import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

const NotFound: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#07070b] flex items-center justify-center p-6">
      <div className="text-center max-w-md">
        <div className="text-8xl font-black text-transparent bg-clip-text bg-gradient-to-r from-[#f6d77a] via-[#d4a237] to-[#a87d2a] mb-4">
          404
        </div>
        <h1 className="text-2xl font-bold text-white mb-2">{t('notFound.title')}</h1>
        <p className="text-white/40 mb-8">
          {t('notFound.desc')}
        </p>
        <button
          onClick={() => navigate('/')}
          className="px-6 py-3 bg-gradient-to-r from-[#f6d77a] via-[#d4a237] to-[#a87d2a] rounded-xl text-[#0b0b10] font-semibold hover:opacity-90 transition-opacity"
        >
          {t('notFound.back')}
        </button>
      </div>
    </div>
  );
};

export default NotFound;
